import ListItem from '@material-ui/core/ListItem';
import { NavLink, Route } from 'react-router-dom';

import NavTooltip from './NavTooltip';

class SidebarNavLink extends React.Component {
  getListItemClassName(active) {
    const { classes, to } = this.props;

    return classnames(classes.listItem, classes.listItemText, {
      [classes.listItemTextSelected]: to && active,
    });
  }

  render() {
    const { to, title, classes, exact, href, onClick, icon } = this.props;

    return (
      <Route exact={exact} path={to}>
        {({ match }) => (
          <NavTooltip
            render={({
              onMouseEnter,
              onMouseLeave,
              getListItemTop,
              parentRef,
            }) => {
              return (
                <ListItem
                  className={classnames(
                    this.getListItemClassName(!!match),
                    this.props.className,
                  )}
                  onClick={onClick}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                  ref={parentRef}>
                  {to && (
                    <NavLink className={classes.unstyledLink} to={to}>
                      {icon}
                      <span className={classes.listItemLabel}>{title}</span>
                    </NavLink>
                  )}
                  {href && (
                    <a className={classes.unstyledLink} href={href}>
                      {icon}
                      <span className={classes.listItemLabel}>{title}</span>
                    </a>
                  )}
                  <div
                    style={{ top: getListItemTop() }}
                    className={classnames(
                      classes.listItemTooltipContent,
                      'nav-tooltip',
                    )}>
                    {title}
                  </div>
                </ListItem>
              );
            }}
          />
        )}
      </Route>
    );
  }
}

SidebarNavLink.defaultProps = {
  exact: false,
};

SidebarNavLink.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  exact: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
};

export default SidebarNavLink;
